const TELEMETRY_ENDPOINT = 'https://b2b-telemetry.uacorporate.com/postevent';
const TELEMETRY_ALLOWED_HOSTS = [
    'veg.uacorporate.com',
    'adventhealth.uacorporate.com',
    'freseniusmedicalcare.uacorporate.com',
];

const isTelemetryEnabled = () => {
    try {
        const host = typeof window !== 'undefined' ? window.location.hostname : '';
        return TELEMETRY_ALLOWED_HOSTS.includes(host);
    } catch (_) {
        return false;
    }
};

const postTelemetryEvent = (event) => {
    if (!isTelemetryEnabled()) return;
    const payload = {
        ...event,
        timestamp: new Date().toISOString(),
        url: typeof window !== 'undefined' ? window.location.href : '',
        userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
        isOnline: typeof navigator !== 'undefined' ? navigator.onLine : undefined,
    };
    const body = JSON.stringify({ events: [payload] });

    try {
        if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
            const blob = new Blob([body], { type: 'application/json' });
            const sent = navigator.sendBeacon(TELEMETRY_ENDPOINT, blob);
            if (sent) return;
        }
    } catch (_) {
        // fallback below
    }

    try {
        fetch(TELEMETRY_ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body,
            keepalive: true,
            credentials: 'omit',
            cache: 'no-store'
        }).catch(() => {});
    } catch (_) {
        // best effort
    }
};

export const logApiError = (step, requestUrl, details = {}) => {
    postTelemetryEvent({
        source: 'api.ts/baseQueryWithReauth',
        step,
        requestUrl: requestUrl ?? 'unknown',
        ...details,
    });
};

export const logFetchError = (requestUrl, error) => {
    logApiError('FETCH_ERROR', requestUrl, {
        errorStatus: error?.status,
        errorMessage: error?.error ?? error?.data?.message ?? '',
    });
};

export default postTelemetryEvent;
